module.exports = (preview = false) => `
query Error404Query {
  error404Collection(preview: ${preview}, limit: 1) {
    items {
      message {
        json
      }
    }
  }
}`;